import axios from 'axios';
import router from '@/router';
import { Message } from 'element-ui';

const API = {
    ADMIN: "/admin",
    ENHANCE: "/enhance",
    ENHANCE_MODE: "/enhancemode",
    ENHANCE_RESOLUTION: "/enhanceresolution",
    ENHANCE_PACKAGE: "/enhancepackage",
    GENERATE_MODE: "/generatemode",
    GENERATE_RESOLUTION: "/generateresolution",
    GENERATE_PACKAGE: "/generatepackage",
    PUBLIC: {
        LOGIN: "/public/login",
        VERIFY: "/public/verify",
        INDEX: "/index",
        PASSWORD_UPDATE: "/passwordUpdate",
    },
    ALL: {
        USER: "/user/all",
        ENHANCE_MODE: "/enhancemode/all",
        ENHANCE_RESOLUTION: "/enhanceresolution/all",
        ENHANCE_PACKAGE: "/enhancepackage/all",
        GENERATE_MODE: "/generatemode/all",
        GENERATE_RESOLUTION: "/generateresolution/all",
        GENERATE_PACKAGE: "/generatepackage/all",
    },
    USER: "/user",
    USER_CREDIT: "/userCredit",
    API_LOGS: "/apiLogs",
    GENERATIONS: "/generations",
    USER_NOTIFICATIONS: "/userNotifications"
}

// 创建 axios 实例
const service = axios.create({
    baseURL: process.env.VUE_APP_BASE_API, // 请求的基础路径，可根据实际情况修改
    timeout: 5000 // 请求超时时间
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // 添加登录Token
        if (localStorage.getItem("AUTH-ADMIN")) {
			config.headers["AUTH-ADMIN"] = localStorage.getItem("AUTH-ADMIN");
		}
        return config;
    },
    error => {
        // 处理请求错误
        console.log(error); 
        return Promise.reject(error);
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data;
        // 根据实际业务需求处理响应数据
        return res;
    },
    error => {
        if (error.status == 401) {
            Message.error("尚未登录！");
            router.push("/login");
        }
        else if (error.status == 500) {
            Message.error("服务端出错！");
        }
    }
);

service.defaults.withCredentials = false;


async function doGet(url, params = {}) {
    return service.get(url, { params });
}

async function doPost(url, params = {}) {
    return service.post(url, params);
}

async function doPut(url, params = {}) {
    return service.put(url, params);
}

async function doPatch(url, params = {}) {
    return service.patch(url, params);
}

async function doDelete(url, id) {
    return service.delete(url + '/' + id);
}

export {
    API,
    doGet,
    doPost,
    doPut,
    doPatch,
    doDelete
}